"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reducer_1 = __importDefault(require("./modules/remoteRecord/reducer"));
var reducer_2 = __importDefault(require("./modules/titles/reducer"));
var reducer_3 = __importDefault(require("./modules/app/reducer"));
var reducer_4 = __importDefault(require("./modules/auth/reducer"));
var reducer_5 = __importDefault(require("./modules/home/reducer"));
var reducer_6 = __importDefault(require("./modules/spotify/reducer"));
var reducer_7 = __importDefault(require("./modules/playback/reducer"));
var reducer_8 = __importDefault(require("./modules/search/reducer"));
var reducer_9 = __importDefault(require("./modules/chromecast/reducer"));
var reducer_10 = __importDefault(require("./modules/channels/reducer"));
var reducer_11 = __importDefault(require("./modules/epg/reducer"));
var reducer_12 = __importDefault(require("./modules/playerNative/reducer"));
var reducer_13 = __importDefault(require("./modules/collections/reducer"));
var reducer_14 = __importDefault(require("./modules/devices/reducer"));
var reducer_15 = __importDefault(require("./modules/myStuff/reducer"));
var reducer_16 = __importDefault(require("./modules/subscription/reducer"));
var reducer_17 = __importDefault(require("./modules/parentalPin/reducer"));
var reducer_18 = __importDefault(require("./modules/download2Go/reducer"));
var reducer_19 = __importDefault(require("./modules/userAttributes/reducer"));
var reducer_20 = __importDefault(require("./modules/network/reducer"));
var reducer_21 = __importDefault(require("./modules/messaging/reducer"));
var reducer_22 = __importDefault(require("./modules/featureFlags/reducer"));
var reducer_23 = __importDefault(require("./modules/airplay/reducer"));
var reducer_24 = __importDefault(require("./modules/myHub/reducer"));
var reducer_25 = __importDefault(require("./modules/myApps/reducer"));
var reducer_26 = __importDefault(require("./modules/recordings/reducer"));
var reducer_27 = __importDefault(require("./modules/decoder/reducer"));
var reducer_28 = __importDefault(require("./modules/customer/reducer"));
var reducer_29 = __importDefault(require("./modules/notificationsTV/reducer"));
var reducer_30 = __importDefault(require("./modules/dvb/reducer"));
var reducer_31 = __importDefault(require("./modules/contextTV/reducer"));
var reducer_32 = __importDefault(require("./modules/tilesFocusTV/reducer"));
var reducer_33 = __importDefault(require("./modules/backgroundImage/reducer"));
var reducer_34 = __importDefault(require("./modules/accountPin/reducer"));
var reducer_35 = __importDefault(require("./modules/profilePreferences/reducer"));
exports.default = {
    app: reducer_3.default,
    auth: reducer_4.default,
    titles: reducer_2.default,
    home: reducer_5.default,
    spotify: reducer_6.default,
    playback: reducer_7.default,
    search: reducer_8.default,
    chromecast: reducer_9.default,
    channels: reducer_10.default,
    epg: reducer_11.default,
    playerNative: reducer_12.default,
    collections: reducer_13.default,
    devices: reducer_14.default,
    myStuff: reducer_15.default,
    remoteRecord: reducer_1.default,
    subscription: reducer_16.default,
    parentalPin: reducer_17.default,
    download2Go: reducer_18.default,
    userAttributes: reducer_19.default,
    network: reducer_20.default,
    messaging: reducer_21.default,
    featureFlags: reducer_22.default,
    airplay: reducer_23.default,
    myHub: reducer_24.default,
    myApps: reducer_25.default,
    recordings: reducer_26.default,
    decoder: reducer_27.default,
    customer: reducer_28.default,
    notificationsTV: reducer_29.default,
    dvb: reducer_30.default,
    contextTV: reducer_31.default,
    tilesFocusTV: reducer_32.default,
    backgroundImage: reducer_33.default,
    accountPin: reducer_34.default,
    profilePreferences: reducer_35.default,
};
//# sourceMappingURL=reducer.js.map